import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, OnDestroy } from '@angular/core';
import { ThemeService } from '@caslink/common-client/ng-app/theme/ThemeService';

@Component({
    selector: 'dl-empty-component',
    template: ''
})
export class EmptyComponent implements OnDestroy {
    public static $name = 'emptyComponent';
    // this is for opening empty dialogs with MatDialog

    private container: HTMLElement;
    private opacityClass: string;

    constructor(
        private overlayContainer: OverlayContainer,
        private themeService: ThemeService
    ) {
        this.container = this.overlayContainer.getContainerElement();
        const opacity = 50;
        this.opacityClass = this.themeService.getOpacityClass(opacity);
        this.container.classList.add(this.opacityClass);
    }

    public ngOnDestroy() {
        this.container.classList.remove(this.opacityClass);
    }
}
